var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-line"},[_c('hr',{class:_vm.classLine})])
}
var staticRenderFns = []

export { render, staticRenderFns }